export default __webpack_public_path__ + "static/media/smartphone_expenses_ocr.19a5dd65.png";